<template>
  <v-container fluid>
    <material-card icon="mdi-clipboard-text" inline title="Sub Categories">
      <v-card flat class="px-2"> </v-card>
      <v-card-actions>
        <a @click="$router.push({ name: 'generallistAuditCategory' })">
          <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top>
            <v-icon left>mdi-arrow-left</v-icon>back
          </v-btn>
          <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1"
            class="mr-n2 mt-10" style="opacity:.6;">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </a>
      </v-card-actions>
      <v-subheader class="font-weight-bold pa-0 darkblue--text">Category Name- {{ categoryName }}
      </v-subheader>
      <v-card-component>
        <v-card-text class="pt-0 pr-1"
          :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
          <v-card-title>
            <v-spacer></v-spacer>
          </v-card-title>
          <!-- <v-text-field
            :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
            v-model="search" append-icon="mdi-magnify" class="ml-auto mb-2" label="Search"
            @input="searchHandler()" hide-details single-line style="max-width:350px;" />
          <v-btn class="mr-3" elevation="1" color="success" @click="getCategories()">
            <v-icon left>mdi-magnify</v-icon>Search
          </v-btn> -->
          <v-btn
            v-on:click="
              () => {
                $router.push({ name: 'addGeneralSubCategory' })
              }
            "
            v-if="isWrite"
            elevation="1"
            :class="{ 'mt-2': $vuetify.breakpoint.xs }"
            color="accent" absolute right
          >
            <v-icon left>mdi-plus</v-icon>
            Create Subcategory
          </v-btn>
        </v-card-text>
        <v-divider class="my-0 py-0"></v-divider>
        <v-data-table v-if="subCategory.length" :headers="headers" :items="subCategory"
          disable-pagination hide-default-footer>
          <template v-slot:[`item.subCategoryName`]="{ item }">
            <span class="text-capitalize"
              v-on:click="addClass(item.id)">{{ item.subCategoryName }}
            </span>
          </template>
          <template v-slot:[`item.parameter`]="{ item }">
            {{ item.parameter.length}}
          </template>
          <template v-slot:[`item.date`]="{ item }">
            {{ item.date }}
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <router-link :to="{ name: 'addGeneralParams', params: { subcategoryId: item.id }}">
              <v-btn color="success" class="px-2 ml-1 ma-1" min-width="0" small>
                <v-icon small>Add Parameter</v-icon>
              </v-btn>
            </router-link>
            <!-- <router-link :to="{ name: 'editGeneralCategory', params: { categoryId: item.id } }">
              <v-btn color="success" class="px-2 ml-1 ma-1" min-width="0" small>
                <v-icon small> mdi-pencil </v-icon>
              </v-btn>
            </router-link> -->
            <v-btn class="px-2 ml-1 ma-1" color="error" min-width="0" small v-if="!item.deletedAt"
              @click.prevent="deleteSubCategory(item)">
              <v-icon small> mdi-delete</v-icon>
            </v-btn>
          </template>

          <template v-slot:no-data>
            <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
          </template>
          <!-- <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length" class="pt-4 pb-4">
              <label class="font-weight-medium body-2">Parameters </label>
              <ul>
                <li v-for="(prm, index) in item.acadAuditParameters" :key="prm.id">{{ index + 1 }}. {{ prm.name }}</li>
              </ul>
            </td>
          </template> -->
        </v-data-table>
        <!--Pagination start-->
        <v-row>
          <v-col cols="4" sm="3">
            <v-select v-model="pageSize" :items="pageSizes" label="Items per Page"
              @change="handlePageSizeChange"></v-select>
          </v-col>
          <v-col cols="12" sm="9">
            <v-pagination v-model="page" :length="totalPages" :total-visible="totalPages"
              @input="handlePageChange"> </v-pagination>
          </v-col>
        </v-row>
        <!--Pagination end-->
      </v-card-component>
    </material-card>
  </v-container>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'
import VCardComponent from '@/components/template/VCardComponent'
import moment from 'moment'

export default {
  components: { VCardComponent, MaterialCard },
  props: ['categoryId', 'subCategoryId'],
  data () {
    return {
      categoryName: '',
      isWrite: true,
      search: '',
      tableData: [],
      lists: [],
      page: 1,
      pageSize: 10,
      pageSizes: [5, 10, 20],
      totalPages: 0,
      subCategory: [],
      parameter: [],
      isActive: false,
      headers: [
        { text: 'Name', value: 'subCategoryName', sortable: true },
        { text: 'No. of Parameters', value: 'parameter', sortable: false },
        { text: 'Last Updated On', value: 'updatedAt', sortable: true },
        // { text: 'Status', value: 'isActive' },
        { text: 'Actions', value: 'actions', align: 'center', sortable: false }
      ]
    }
  },
  created: async function () {
    await this.getCategoryDetails()
    // await this.getCategories()
  },
  methods: {
    addClass (id) {
      this.$router.push({ name: 'generalParameterList', params: { subcategoryId: id } })
    },
    getCategoryDetails: async function () {
      try {
        let res = await http.get(`${CONSTANTS.API_URL}/api/audit/audit-category/getbyid/${this.categoryId}`)
        this.name = res.data.name
        this.position = res.data.position
        this.categoryName = res.data.categoryName
        this.selectedAcademicYear = res.data.academicYearID
        this.parameter = res.data.parameter
        this.subCategory = res.data.subCategory.map(a => {
          a.updatedAt = moment(a.updatedAt, 'YYYY-MM-DD').format('D MMM, YYYY')
          return a
        })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
      }
    },

    // getSubCategories: async function () {
    //   try {
    //     this.isLoading = true
    //     let res = await http.get(`${CONSTANTS.API_URL}/api/audit/audit-category/get`, {
    //       params: {
    //         page: this.page - 1,
    //         size: this.pageSize
    //         // search: this.search
    //       }
    //     })

    //     this.lists = res.data.rows.map((item, index) => {
    //       item.srno = this.pageSize * (this.page - 1) + index + 1
    //       item.auditDate = moment(item.updatedAt).format('MMM Do YYYY')
    //       return item
    //     })
    //     this.totalPages = res.data.totalPages
    //   } catch (e) {
    //     const errorMessage = (e && e.response && e.response.data.message) || e.message
    //     this.errMsg(errorMessage)
    //   } finally {
    //     this.isLoading = false
    //   }
    // },

    deleteSubCategory: function (item) {
      let that = this
      this.$dialog.warning({
        title: item.isActive === true ? 'Deactivate' : 'Activate',
        text: 'Are you sure you want to delete this subcategory?',
        actions: {
          true: {
            color: 'success',
            text: 'Yes',

            handle: async () => {
              try {
                this.isLoading = true
                return http
                  .put(`${CONSTANTS.API_URL}/api/audit/audit-subcategory/delete/${item.id}`, {
                    isActive: item.isActive
                    // roleName: item.roleName
                  })
                  .then(() => {
                    that.getCategoryDetails()
                    this.isLoading = false
                    return this.$dialog.info({
                      title: 'Success',
                      text: 'Subcategory Deleted successfully.'
                    })
                  })
              } catch (httpException) {
                console.warn('Error while deleting Role', httpException.message)
                this.isLoading = false

                return this.$dialog.error({
                  title: 'Error',
                  text: 'Error while Deleting Subcategory'
                })
              } finally {
                this.isLoading = false
              }
            }
          }
        }
      })
    },
    okMsg (msg) {
      return this.$dialog.info({
        text: msg,
        title: 'Success'
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    },
    handlePageChange: function () {
      console.log(`Page: ${this.page}`)
      this.getCategories()
    },
    handlePageSizeChange: function () {
      console.log(`Page Size: ${this.pageSize}`)
      this.getCategories()
    }
    // searchHandler: function () {
    //   if (this.search.length > 3) {
    //     this.getCategories()
    //   }
    // }
  }
}
</script>
